module.exports = __webpack_public_path__ + "img/part1-2.e6f2ff0b.png";